function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Rnd } from 'react-rnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faDirections } from '@fortawesome/free-solid-svg-icons';
import './TrackInfo.css';

var TrackInfo = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TrackInfo, _React$PureComponent);

  function TrackInfo(props) {
    var _this;

    _classCallCheck(this, TrackInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrackInfo).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "openTrackEmail", function () {
      var track = _this.props.track;

      if (track && track.email) {
        window.open("mailto:".concat(track.email));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openTrackUrl", function () {
      var track = _this.props.track;

      if (track && track.website_url) {
        window.open(track.website_url, '_new');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "navigateTo", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var track = _this.props.track;

      if (window.cordova) {
        directions.navigateTo(track.position.lat, track.position.lng);
      } else {
        var link = document.createElement('a');
        link.href = "geo:".concat(track.position.lat, ",").concat(track.position.lng);
        link.click();
        link.remove();
      }
    });

    _this.state = {
      x: 100,
      y: window.cordova ? 35 : 25,
      width: 450,
      height: 180
    };
    return _this;
  }

  _createClass(TrackInfo, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var openTrackEmail = this.openTrackEmail,
          openTrackUrl = this.openTrackUrl,
          navigateTo = this.navigateTo;
      var _this$props = this.props,
          app = _this$props.app,
          track = _this$props.track;
      var _this$state = this.state,
          x = _this$state.x,
          y = _this$state.y,
          width = _this$state.width,
          height = _this$state.height;
      return React.createElement(Rnd, {
        className: "track-info ".concat(track ? 'show' : 'hide', " ").concat(window.cordova ? 'mobile' : ''),
        size: {
          width: width,
          height: height
        },
        position: {
          x: x,
          y: y
        },
        onDragStop: function onDragStop(e, d) {
          _this2.setState({
            x: d.x,
            y: d.y
          });
        },
        onResizeStop: function onResizeStop(e, direction, ref, delta, position) {
          _this2.setState({
            x: position.x,
            y: position.y,
            width: Math.max(25, ref.style.width),
            height: Math.max(25, ref.style.height)
          });
        }
      }, React.createElement("div", {
        className: "close",
        onClick: function onClick(e) {
          return app.setActiveTrack(undefined);
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faTimes
      })), React.createElement("div", {
        className: "get-directions",
        onClick: navigateTo
      }, React.createElement(FontAwesomeIcon, {
        icon: faDirections
      })), track && React.createElement("div", {
        className: "detail-layout"
      }, React.createElement("div", {
        className: "district-container"
      }, React.createElement("div", {
        className: "district"
      }, track.district)), React.createElement("div", {
        className: "details"
      }, React.createElement("div", {
        className: "trackname"
      }, React.createElement("span", {
        style: {
          display: 'block'
        }
      }, track.name)), React.createElement("div", {
        className: "state"
      }, track.state), React.createElement("div", {
        className: "operator"
      }, track.primary_contact_name), React.createElement("div", {
        className: "phone"
      }, track.primary_contact_phone), React.createElement("div", {
        className: "email",
        onClick: openTrackEmail
      }, track.email), React.createElement("div", {
        className: "url",
        onClick: openTrackUrl
      }, track.website_url))));
    }
  }]);

  return TrackInfo;
}(React.PureComponent);

export default TrackInfo;